import { ProtectedRoute } from '@components';

import { usePermissions } from '../hooks/usePermissions';

/**
 * Gates the Template Create route behind `canManageTemplates` — Standard users who navigate to
 * `/templates/new` directly are redirected back to the read-only Template Manager list. Editing
 * an existing template (`/templates/:id/edit`) stays reachable by Standard users — `TemplateEditorPage`
 * itself renders that route read-only for them instead of blocking access entirely. See
 * `usePermissions.ts` for how this will connect to real backend authorization later.
 */
export const TemplateManagerProtectedRoute: React.FC = () => {
  const { canManageTemplates } = usePermissions();
  return <ProtectedRoute isAllowed={canManageTemplates} redirectPath="/templates" />;
};
